module.exports = __webpack_public_path__ + "static/media/technical-frame.7179bccc.png";